import { useId } from 'react'

import { Switch } from '@/components/ui'

import { cn } from '@/lib/cn'

export interface ToggleFieldProps {
  label: string
  description?: string
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

/** A labelled switch row. The whole 44px control is the hit target, not just the track. */
export function ToggleField({
  label,
  description,
  checked,
  onChange,
  disabled,
  className,
}: ToggleFieldProps) {
  const labelId = useId()
  const descriptionId = `${labelId}-description`

  return (
    <div className={cn('flex items-center justify-between gap-4', className)}>
      <div className="min-w-0">
        <p id={labelId} className="text-sm font-medium text-text">
          {label}
        </p>
        {description ? (
          <p id={descriptionId} className="mt-0.5 text-sm text-text-muted">
            {description}
          </p>
        ) : null}
      </div>

      <Switch checked={checked} onCheckedChange={onChange} disabled={disabled}
        aria-labelledby={labelId} aria-describedby={description ? descriptionId : undefined} />
    </div>
  )
}
